module.exports = __webpack_public_path__ + "static/lento-eaf9590f83f29d1c1cbbabd39a843cc9.webp";